<!-- 
    COMPONENT project
-->


<!---------- SCRIPT ---------->

<script lang="ts">
    
    import type { Project } from "../models/project";
    import { deglingos, minitel, english } from '../store/store'

    export let props: Project;

    let is_title: boolean = true;

    function isTitle() {
        if (is_title) {
            is_title = false;
            return true;
        } else {
            return false;
        }
    }
</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">
    .project {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        background-color: $color_primary;
        color: $color_secondary;
        border: 1px solid $color_secondary;
        box-shadow: 8px 8px 8px $color_black;
        transition: background-color 1s linear;
        width: 200px;
        height: 300px;
        border-radius: 8px;
        margin: 24px 8px 24px 8px;
        &:hover {
            background-color: $color_secondary;
            color: $color_primary;
            border: 1px solid $color_primary;
            box-shadow: 8px 8px 8px $color_primary;
        }
        &__front {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            align-content: center;
        }
        &__back {
            display: none;
        }
        &:hover &__back {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            align-content: center;
            text-align: center;
        }
        &:hover &__front {
            display: none;
        }
        &__h1 {
            padding: 0 8px 0 8px;
            font-size: 1.1em;
            text-shadow: none;
            text-align: center;
        }
        &__img {
            width: 160px;
            height: 160px;
            object-fit: contain;
        }
        &__p {
            padding: 0 8px 0 8px;
            text-shadow: none;
        }
        &__click {
            display: block;
            font-size: x-small;
            &__deglingos {
                text-shadow: none;
            }
        }
    }

    .projectMinitel {
        border-top: 1px;
        border-right: 0px;
        border-left: 0px;
        border-bottom: 0px;
        border-color: $color_minitel_green;
        border-style: dotted;
        margin: 40px 0 0 0;
        display: flex;
        flex-direction: column;
        color: $color_minitel_green;
        width: 100%;
        &__front {
            color: $color_minitel_blue;
        }
        &__back {
            color: $color_white;
        }
        &__click {
            display: none;
        }
        &__h1 {
            color: $color_minitel_blue;
        }
        &__p {
            text-decoration: underline dotted;
        }
    }


    @include large {
        .project {
            &__click {
                display: none;
            }
        }
        .projectMinitel {
            flex-direction: row;
            &__front {
                min-width: 300px;
            }
        }
    }

</style>
  
  
<!---------- TEMPLATE ---------->

<div class:project={!$minitel} class:projectMinitel={$minitel}>
    <div class:project__front={!$minitel} class:projectMinitel__front={$minitel}>
        <h1 class:project__h1={!$minitel} class:projectMinitel__h1={$minitel}>{props.title}</h1>
        <img class="project__img" src={props.image} alt="logo du projet">
        {#if $english}
            <p class:project__click={!$minitel} class:project__click__deglingos={$deglingos} class:projectMinitel__click={$minitel}>more ...</p>
        {:else}
            <p class:project__click={!$minitel} class:project__click__deglingos={$deglingos} class:projectMinitel__click={$minitel}>plus d'infos ...</p>
        {/if}
    </div>
    <div class:project__back={!$minitel} class:projectMinitel__back={$minitel}>
        {#each props.description as desc}
        {#if isTitle()}
            <p class:project__p={!$minitel} class:projectMinitel__p={$minitel}><strong>{desc}</strong></p>
        {:else}
            <p class:project__p={!$minitel} class:projectMinitel__p={$minitel}>{desc}</p>
        {/if}
        {/each}
        {#if props.url != ""}
            <a href={props.url} target="_blank">{props.url.substring(8)}</a>
        {/if}
    </div>
</div>